import { Component, EventEmitter, Output } from '@angular/core';

/**
 * Handles raci template new component
 */
@Component({
  selector: 'raci-template-new',
  templateUrl: './raci-template-new.component.html',
  styleUrls: ['./raci-template-new.component.css']
})
export class RaciTemplateNewComponent {
  /**
  * Should close?
  */
  shouldClose = false;

  /**
  * Close pane event listener
  */
  @Output() closePane: EventEmitter<any> = new EventEmitter();

  /**
   * Close with refresh event listener
   */
  @Output() closeWithRefresh: EventEmitter<any> = new EventEmitter();

  /**
  * Close click event handler
  */
  onCloseClicked(): void {
    this.shouldClose = true;
    setTimeout(() => {
      this.closePane.emit();
    }, 500);//let animation finish
  }

  /**
   *  Close with refresh click event handler
   */
  onCloseWithRefresh() {
    this.closeWithRefresh.emit();
  }
}
